// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDpnXYdTvJKF8nO9hrzzXXPQE0Y3FieM9k",
  authDomain: "stocai.firebaseapp.com",
  projectId: "stocai",
  storageBucket: "stocai.firebasestorage.app",
  messagingSenderId: "132540449116",
  appId: "1:132540449116:web:434f1140250edc8c8cc199",
  measurementId: "G-G22TJCKW0B"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);  // ✅ Initialize Firebase Auth
const analytics = getAnalytics(app);

export { app, auth, analytics };  // ✅ Export auth for use in GoogleForm.jsx
